// Add your custom JS here.
import domReady from '@wordpress/dom-ready';
import apiFetch from '@wordpress/api-fetch';

domReady( function () {

    
    // hambuger nav
    const hamburger = document.querySelector('.hamburger');
    const nav = document.querySelector('#drawer-nav');
    hamburger.addEventListener('click', function (e) {
        e.preventDefault();
        hamburger.classList.toggle('is-active');
        nav.classList.toggle('is-active');
        document.body.classList.toggle("is-nav-open");
    });


    
    // load more latest posts
    const loadMoreButton = document.querySelector('.load-more-post');
    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", handleLoadMoreClick);
    }

    function handleLoadMoreClick(event) {
        event.preventDefault();
        const button = event.target;
        const spinner = document.querySelector('.spinner-border');
        let dataPageValue = parseInt(button.getAttribute("data-page"));
        let dataPagesValue = parseInt(button.getAttribute("data-pages"));
        let dataFeatured = parseInt(button.getAttribute("data-featured"));
        dataPageValue++;
        button.classList.add("d-none");
        spinner.classList.remove("d-none");

        // AJAX request
        // Create a new FormData object
        const formData = new FormData();
        formData.append('action', 'load_more_posts');
        formData.append('dataPageValue', dataPageValue);
        formData.append('dataFeatured', dataFeatured);
        formData.append('nonce', custom_vars.nonce );
        fetch(custom_vars.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            const loadMorePostsDiv = document.getElementById('load-more-posts');
            loadMorePostsDiv.innerHTML += data.html;
            loadMorePostsDiv.scrollIntoView({ behavior: 'smooth' });
            button.setAttribute("data-page", dataPageValue);
            spinner.classList.add("d-none");
            if(dataPageValue < dataPagesValue){
                button.classList.remove("d-none");
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }


    // handle category block select
    const selectElement = document.getElementById('custom-select');
    if (selectElement) {
        // Dropdown Menu
        document.querySelectorAll('.dropdown-select-btn').forEach(function(dropdown) {

            const dropdownEl = dropdown.parentElement;

            dropdown.addEventListener('click', function() {

                dropdownEl.setAttribute('tabindex', '1');
                dropdownEl.classList.toggle('active');
                dropdownEl.querySelector('.dropdown-menu').style.display = dropdownEl.classList.contains('active') ? 'block' : 'none';
                this.setAttribute('aria-expanded', dropdownEl.classList.contains('active') ? 'true' : 'false');
            });
            
            dropdown.addEventListener('focusout', function() {
                this.classList.remove('active');
                if(this.querySelector('.dropdown-menu')) {
                    this.querySelector('.dropdown-menu').style.display = 'none';
                }
            });
            
            dropdownEl.querySelectorAll('.dropdown-menu li').forEach(function(item) {
                item.addEventListener('click', function() {
                    var dropdownParent = this.closest('.dropdown');
                    dropdownParent.querySelector('span').textContent = this.textContent;
                    dropdownParent.querySelector('input').setAttribute('value', this.getAttribute('id'));
                    checkCategorySelect(this.getAttribute('id'));
                });
            });
        });
    
        // End Dropdown Menu

        document.querySelectorAll('.dropdown-menu li').forEach(function(item) {
            item.addEventListener('click', function() {
            var input = '<strong>' + this.closest('.dropdown').querySelector('input').value + '</strong>';
            var msg = '<span class="msg">Hidden input value: ';
            // document.querySelector('.msg').innerHTML = msg + input + '</span>';
            });
        });

        //   onload
        document.querySelectorAll('.dropdown-menu li').forEach(function(item) {
            let selected = item.getAttribute("data-selected");
            if(selected){
                var dropdownParent = item.closest('.dropdown');
                dropdownParent.setAttribute('tabindex', '1');
                dropdownParent.querySelector('span').textContent = item.textContent;
                dropdownParent.querySelector('input').setAttribute('value', item.getAttribute('id'));
            }
        });

        

        function checkCategorySelect(categoryValue) {
            // let categoryValue = selectElement.value;
            let dataPageValue = 1;
            // AJAX request
            // Create a new FormData object
            const formData = new FormData();
            formData.append('action', 'load_more_posts');
            formData.append('dataPageValue', dataPageValue);
            formData.append('categoryValue', categoryValue);
            formData.append('nonce', custom_vars.nonce );
            const loadMorePostsDiv = document.getElementById('category-wrapper');
            //  add spinner
            loadMorePostsDiv.innerHTML = '<div class="spinner-border d-none" role="status"> <span class="visually-hidden">Loading...</span></div>';
            // hide load more
            const loadMoreBtn = document.getElementById('load-more-btn-category');
            // update the values
            loadMoreBtn.setAttribute("data-page", 1);
            loadMoreBtn.setAttribute("data-category", categoryValue);
            //hide
            loadMoreBtn.classList.add("d-none");

            //empy load more
            const morePostsDiv = document.getElementById('load-more-category-posts');
            morePostsDiv.innerHTML = '';

            fetch(custom_vars.ajax_url, {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                
                // Close dropdown if data returned
                const cwActiveDropDown = document.querySelector('.cat-select-dropdown.active');
                if(cwActiveDropDown) {
                    cwActiveDropDown.classList.remove('active');
                    cwActiveDropDown.querySelector('.dropdown-select-btn').setAttribute('aria-expanded', false);
                    document.getElementById('custom-select-dropdown').style.display = 'none';
                }



                loadMorePostsDiv.innerHTML = data.html;
                loadMorePostsDiv.scrollIntoView({ behavior: 'smooth' });
                //handle the load more
                let pages = data.pages;
                if(pages > 1){
                    loadMoreBtn.classList.remove("d-none");
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }

    }

    // handle category block load more
    // load more latest posts
    const loadMoreBtnCat = document.getElementById('load-more-btn-category');
    if (loadMoreButton) {
        loadMoreBtnCat.addEventListener("click", handleLoadMoreClickCat);
    }

    function handleLoadMoreClickCat(event) {
        event.preventDefault();
        const button = event.target;
        const spinner = document.querySelector('.spinner-border-category');
        let dataPageValue = parseInt(button.getAttribute("data-page"));
        let dataPagesValue = parseInt(button.getAttribute("data-pages"));
        let categoryValue = parseInt(button.getAttribute("data-category"));
        dataPageValue++;
        button.classList.add("d-none");
        spinner.classList.remove("d-none");

        // AJAX request
        // Create a new FormData object
        const formData = new FormData();
        formData.append('action', 'load_more_posts');
        formData.append('dataPageValue', dataPageValue);
        formData.append('categoryValue', categoryValue);
        formData.append('nonce', custom_vars.nonce );
        fetch(custom_vars.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            const loadMorePostsDiv = document.getElementById('load-more-category-posts');
            loadMorePostsDiv.innerHTML += data.html;
            loadMorePostsDiv.scrollIntoView({ behavior: 'smooth' });
            button.setAttribute("data-page", dataPageValue);
            spinner.classList.add("d-none");
            let pages = data.pages;
            if(pages > 1 && dataPageValue < pages){
                button.classList.remove("d-none");
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }



    //contact form
    const concactFormOpenBtn = document.getElementById('cw-switch-button');
    if (concactFormOpenBtn) {
        concactFormOpenBtn.addEventListener("click", handleContactForm);

        const customContactBtns = document.querySelectorAll('.cw-contact-trigger');

        if(customContactBtns) {
            customContactBtns.forEach(button => {
                button.addEventListener('click', handleContactForm );
            });
        }
    }

    function handleContactForm(event = null) {
        if(event) {
            event.preventDefault();
        }
        const body = document.body;
        body.classList.toggle('overflow-hidden');
        const button = document.getElementById('cw-switch-button');
        button.classList.toggle("active");
        const formHolder = document.getElementById('cw-contact-form');
        formHolder.classList.toggle("active");
        let checkBg = document.getElementById('bg-contact');

        if(checkBg) {
            checkBg.removeEventListener('click', handleContactForm);
            checkBg.parentNode.removeChild(checkBg);
        } else {
            document.addEventListener('keydown', (e) => {
                if(!document.querySelector('.cw-team-member__bio.active') && document.getElementById('bg-contact')) {
                    if(e.key === 'Escape') {
                        handleContactForm();
                    }
                }
            });
            const bg = document.createElement('div');
            bg.id = 'bg-contact';
            document.body.appendChild(bg);
            setTimeout(() => {
                bg.classList.add("active");

                bg.addEventListener('click', handleContactForm);
            }, 100);
        }
    }

    //video player good for youtube only
    document.querySelectorAll('.video-play').forEach(function(btnVideo) {
        btnVideo.addEventListener('click', function() {
            this.closest('.poster').classList.add('d-none');
            this.closest('.video-wrapper').querySelector('.iframe').classList.remove('d-none')
            let iframe = this.closest('.video-wrapper').querySelector('iframe');
            let iframeWrapper = this.closest('.video-wrapper').querySelector('.iframe');
            setTimeout(() => {
                let videoId = getYouTubeVideoId(iframe.src);
                let player = new YT.Player(iframeWrapper, {
                    videoId: videoId,
                        events: {
                        'onReady': onPlayerReady,
                        }
                });
                function onPlayerReady(event) {
                    event.target.playVideo();
                }
            }, 100);
        });
    });
    function getYouTubeVideoId(url) {
        var regExp = /^(?:https?:\/\/(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/)|https?:\/\/youtu\.be\/)([^\s&]{11})/;
        var match = url.match(regExp);
        if (match && match[1]) {
            return match[1];
        }
        return null;
    }
    //video player good for youtube only



    /*
        Block - Informational Tab Block
    */
    const infoTabBtns = document.querySelectorAll('.cw-tab-btn');

    if(infoTabBtns) {

        infoTabBtns.forEach(button => {
            button.addEventListener('click', function() {

                if(!button.classList.contains('cw-tab-btn--active')){
                    const buttonID = button.id;
                    const buttonNumber = buttonID.substring(buttonID.indexOf('--') + 2);
                    const tabContentID = 'cw-tab-content--' + buttonNumber;

                    document.querySelector('.cw-tab-content.d-flex').classList.remove('d-flex');
                    document.getElementById(tabContentID).classList.add('d-flex');

                    document.querySelector('button.cw-tab-btn--active').setAttribute('aria-expanded', false);
                    document.querySelector('button.cw-tab-btn--active').classList.remove('cw-tab-btn--active');
                    
                    button.classList.add('cw-tab-btn--active');
                    button.setAttribute('aria-expanded', true);

                    if(window.matchMedia("(max-width: 1000px)").matches) {
                        const buttonElWidth = document.querySelector('.cw-tab-btn').offsetWidth + 19;

                        document.querySelector('.cw-tab-headings-wrap').scroll({
                            left: (buttonNumber * buttonElWidth) - (buttonElWidth + 34),
                            top: 0,
                            behavior: 'smooth'
                        });
                    }

                }

            })
        });



    } 

    /*
        Block - Team Member Block
    */
    const teamMemberBioBtns = document.querySelectorAll('.cw-team-member__btn');

    if(teamMemberBioBtns) {
        const teamMemberBioCloseBtns = document.querySelectorAll('.cw-team-member__bio__closebtn');

        teamMemberBioBtns.forEach(teamButton => {

            teamButton.addEventListener('click', e => {
                e.preventDefault();

                const teamButtonID = teamButton.id;
                const teamButtonNumber = teamButtonID.substring(teamButtonID.indexOf('--') + 2);
                const teamBioID = 'cw-team-member__bio--' + teamButtonNumber;
                const teamMemberBioModal = document.getElementById(teamBioID);

                teamMemberBioModal.classList.add('active');
                teamButton.setAttribute('aria-expanded', true);

                document.querySelector('body').style.overflow = 'hidden';

                document.querySelector('.cw-team-member__bio.active').addEventListener('click', (e) => {
                    const clickTarget = e.target;

                    if(clickTarget.classList.contains('cw-team-member__bio')) {
                        const activeBioModal =  document.querySelector('.cw-team-member__bio.active');

                        if(activeBioModal) {
                            document.querySelector('body').style.overflow = 'auto';
                                
                            activeBioModal.classList.remove('active');
            
                            teamMemberBioBtns.forEach(teamButton => {
                                teamButton.setAttribute('aria-expanded', false);
                            });
                        }
                    }

               });

                document.addEventListener('keydown', e => {
                    e.preventDefault();

                    if(e.key === 'Escape') {
                        const activeBioModal =  document.querySelector('.cw-team-member__bio.active');

                        if(activeBioModal) {
                            document.querySelector('body').style.overflow = 'auto';
                            
                            activeBioModal.classList.remove('active');
            
                            teamMemberBioBtns.forEach(teamButton => {
                                teamButton.setAttribute('aria-expanded', false);
                            });
                        }
                    }
                });
            });

        });


        teamMemberBioCloseBtns.forEach(bioCloseBtn => {

            bioCloseBtn.addEventListener('click', e => {
                e.preventDefault();
                document.querySelector('body').style.overflow = 'auto';
                const activeBioModal =  document.querySelector('.cw-team-member__bio.active');

                if(activeBioModal) {
                    activeBioModal.classList.remove('active');

                    teamMemberBioBtns.forEach(teamButton => {
                        teamButton.setAttribute('aria-expanded', false);
                    });
                }

            });

        });
    }





    const animatedPageTemplate = document.querySelector('.page-template-cw-animated-page');

    if(animatedPageTemplate) {

        if(document.querySelector('.cw-highlighted-text-boxes .cw-highlighted-text')) {

            const sectionPositionTop = document.querySelector('.cw-highlighted-text-boxes .cw-highlighted-text').offsetTop;
            let animationStartPoint = sectionPositionTop - 1000;
            let boxCount = 0;
            let animationMultiplier = 140;

            if(window.matchMedia("(max-width: 700px)").matches) {
                animationStartPoint = sectionPositionTop - 550;
                animationMultiplier = 75;
            }

            document.querySelectorAll('.cw-highlighted-text').forEach(function(text) {
                boxCount++;
                var thisAnimationStartPoint = animationStartPoint + (boxCount * animationMultiplier);
                var animationTime = thisAnimationStartPoint + (animationMultiplier * boxCount);
                gsap.to(text, {
                    width: "100%",
                    opacity: 1,
                    scrollTrigger: {
                        start: thisAnimationStartPoint, // the default values
                        end: animationTime,
                        // duration: animationTime,
                        scrub: true,
                        once: true,
                    }
                });
            });
        }




        if(document.querySelector('.cw-animation') || document.querySelector('.cw-animation-slow')) {
            
            setTimeout(() => {

                if(document.querySelector('.cw-animation-slow')) {
                    gsap.to(".cw-animation-slow", {
                        yPercent: -45,
                        ease: "none",
                        scrollTrigger: {
                        start: "top bottom",
                        // end: "bottom top",
                        scrub: true
                        }, 
                    });
                }
                if(document.querySelector('.cw-animation')) {
                    gsap.to(".cw-animation", {
                        yPercent: 45,
                        ease: "none",
                        scrollTrigger: {
                        //   trigger: ".section-bg-gradient",
                        start: "top bottom", // the default values
                        end: "bottom top",
                        // start: "bottom top", // the default values
                        // end: "top bottom",
                        scrub: true
                        }, 
                    });
                }

            }, 500);

        }
    }


    /*
        Logo Slider
    */
    if(document.querySelector('.cw-company-logos')) {

        const logoSliderSectionEl = document.querySelector('.cw-company-logos');
        const logoSliderEl = logoSliderSectionEl.querySelector('.logo-slider');

        if(logoSliderEl) {
            if(window.matchMedia("(max-width: 800px)").matches) {
                var flktyThreeColSlider = new Flickity( logoSliderEl, {
                    /*
                        Options
                    */
                    cellAlign: 'left',
                    autoPlay: 4000,
                    pauseAutoPlayOnHover: true,
                    pageDots: false,
                    prevNextButtons: false,
                });
            } else {
                var flktyThreeColSlider = new Flickity( logoSliderEl, {
                    /*
                        Options
                    */
                    cellAlign: 'left',
                    draggable: false,
                    autoPlay: 4000,
                    pauseAutoPlayOnHover: true,
                    contain: true,
                    // groupCells: true,
                    pageDots: false,
                    prevNextButtons: false,
                });
            }
        }

    }


    // Impact Page Animation
    const impactSectionEl = document.querySelector('.cw-impact-animated-section');
    if(impactSectionEl) {
        const arrowHeadings = impactSectionEl.querySelectorAll('.cw-impact-animated-section .cw-arrow-hover-area');
        const siteDomain = document.location.host;
        let hasAnimated1 = false;
        let hasAnimated2 = false;
        let hasAnimated3 = false;
        let lastArrowNumber = 0;

        
        setTimeout(() => {

            if(document.getElementById('cw-impact-animated-section__image--1')) {
                document.getElementById('cw-impact-animated-section__image--1').classList.add('invisible');
            }
            if(document.getElementById('cw-impact-animated-section__image--2')) {
                document.getElementById('cw-impact-animated-section__image--2').classList.add('invisible');
            }
            if(document.getElementById('cw-impact-animated-section__image--3')) {
                document.getElementById('cw-impact-animated-section__image--3').classList.add('invisible');
            }

        }, 200);


        if(animatedPageTemplate) {

            const firstImageEl = document.getElementById('cw-impact-animated-section__image');
            firstImageEl.style.opacity = 0;

            const myEnterFunc = () => {

                const activeImg = document.querySelector('.cw-impact-animated-section__image.active');
                if(activeImg){
                    setTimeout(() => {
                        firstImageEl.style.opacity = 1;
                        activeImg.src = 'https://'+siteDomain+'/wp-content/themes/clearwater/images/Impact.gif';
                    }, 200);
                }
            }

            ScrollTrigger.create({
                trigger: '.cw-impact-animated-section',
                onEnter: myEnterFunc,
            });

        }

        arrowHeadings.forEach(arrowHeading => {
            arrowHeading.addEventListener('mouseenter', () => {

                const arrowHeadingNumber = arrowHeading.id.split("--").pop();

                if(arrowHeadingNumber) {

                    const activeImageEl = document.querySelector('.cw-impact-animated-section__image.active');
                    const animatedImageEl = document.getElementById('cw-impact-animated-section__image--'+arrowHeadingNumber);

                    
                    if(activeImageEl) {

                        if(lastArrowNumber != arrowHeadingNumber) { 

                            if(arrowHeadingNumber == 1) { 

                                if(!hasAnimated1) {
                                    const animatedImageElSrc = animatedImageEl.src;
                                    animatedImageEl.src = '';
                                    animatedImageEl.src = animatedImageElSrc;
                                    animatedImageEl.classList.remove('invisible');
                                    setTimeout(() => {
                                        activeImageEl.classList.add('d-none');
                                    }, 10);
                                    activeImageEl.classList.remove('active');
                                    animatedImageEl.classList.add('active');

                                    lastArrowNumber = 1;
                                    hasAnimated1 = true;
                                } else {
                                    activeImageEl.src = 'https://'+siteDomain+'/wp-content/themes/clearwater/images/Impact-1.gif';
                                    lastArrowNumber = 1;
                                }
                            }



                            if(arrowHeadingNumber == 2) { 
                                if(!hasAnimated2) {
                                    const animatedImageElSrc = animatedImageEl.src;
                                    animatedImageEl.src = '';
                                    animatedImageEl.src = animatedImageElSrc;
                                    animatedImageEl.classList.remove('invisible');
                                    setTimeout(() => {
                                        activeImageEl.classList.add('d-none');
                                    }, 10);
                                    activeImageEl.classList.remove('active');
                                    animatedImageEl.classList.add('active');

                                    lastArrowNumber = 2;
                                    hasAnimated2 = true;
                                } else {
                                    activeImageEl.src = 'https://'+siteDomain+'/wp-content/themes/clearwater/images/Impact-2.gif';
                                    lastArrowNumber = 2;
                                }
                            }

                            if(arrowHeadingNumber == 3) { 
                                if(!hasAnimated3) {
                                    const animatedImageElSrc = animatedImageEl.src;
                                    animatedImageEl.src = '';
                                    animatedImageEl.src = animatedImageElSrc;
                                    animatedImageEl.classList.remove('invisible');
                                    setTimeout(() => {
                                        activeImageEl.classList.add('d-none');
                                    }, 10);
                                    activeImageEl.classList.remove('active');
                                    animatedImageEl.classList.add('active');

                                    lastArrowNumber = 3;
                                    hasAnimated3 = true;
                                } else {
                                    activeImageEl.src = 'https://'+siteDomain+'/wp-content/themes/clearwater/images/Impact-3.gif';
                                    lastArrowNumber = 3;
                                }
                            }
                        }
                    }
                }

            });
        });
    }



    // Approach Page Animation
    const approachSectionEl = document.querySelector('.cw-approach-animated-section');
    if(approachSectionEl) {

        const approachLinkBoxes = document.querySelectorAll('.cw-animated-gif__linkbox');
        const approachImageEl = document.getElementById('cw-approach-animated-section__image');

        const approachSiteDomain = document.location.host;
        const approachImgSrc = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach.gif';
        const approachImgSrc1 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-1.gif';
        const approachImgSrc2 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-2.gif';
        const approachImgSrc3 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-3.gif';
        const approachImgSrc4 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-4.gif';
        const approachImgSrc5 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-5.gif';
        const approachImgSrc6 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-6.gif';
        const approachImgSrc7 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-7.gif';
        const approachImgSrc8 = 'https://'+approachSiteDomain+'/wp-content/themes/clearwater/images/Approach-8.gif';
        

        if(approachLinkBoxes) {

            let isAnimating = false;

            function pauseOtherAnimations(pauseTime = 950) {
                isAnimating = true;

                setTimeout(() => {
                    isAnimating = false;
                }, pauseTime);
            }


            // run on load
            approachImageEl.classList.remove('opacity-0');
            // always play animation on load
            approachImageEl.src = approachImgSrc;
            pauseOtherAnimations(3000);

            approachLinkBoxes.forEach(approachBox => {
                // listen for hover
                approachBox.addEventListener('mouseenter', () => {

                    if(isAnimating) {
                        return;
                    }

                    const approachBoxNumber = approachBox.id.split("--").pop();

                    if(approachBoxNumber == 1) {

                        if(!isAnimating) {
                            pauseOtherAnimations();

                            approachImageEl.src = approachImgSrc1;
                            setTimeout(() => {
                                approachImageEl.src = approachImgSrc2;
                            }, 600);
                        }
                    }

                    if(approachBoxNumber == 2) {
                        if(!isAnimating) {
                            pauseOtherAnimations();

                            approachImageEl.src = approachImgSrc3;
                            setTimeout(() => {
                                approachImageEl.src = approachImgSrc4;
                            }, 600);
                        }
                    }

                    if(approachBoxNumber == 3) {
                        if(!isAnimating) {
                            pauseOtherAnimations();

                            approachImageEl.src = approachImgSrc5;
                            setTimeout(() => {
                                approachImageEl.src = approachImgSrc6;
                            }, 600);
                        }
                    }

                    if(approachBoxNumber == 4) {
                        if(!isAnimating) {
                            pauseOtherAnimations();

                            approachImageEl.src = approachImgSrc7;
                            setTimeout(() => {
                                approachImageEl.src = approachImgSrc8;
                            }, 600);
                        }
                    }
                }); // mouseenter event listener

            }); // foreach approachBox

        }
    } // if approach section


    
});